export type MarketingPricingFrequency = 'annual' | 'monthly';

export type MarketingPlanPrices = {
  annualPrice: string;
  introductoryMonthlyPrice?: string;
  monthlyPrice: string;
};

export function resolveMarketingPlanPrice(
  plan: MarketingPlanPrices,
  frequency: MarketingPricingFrequency
): { compareAt?: string; price: string } {
  if (frequency === 'annual') return { price: plan.annualPrice };
  if (plan.introductoryMonthlyPrice) {
    return {
      compareAt: plan.monthlyPrice,
      price: plan.introductoryMonthlyPrice,
    };
  }
  return { price: plan.monthlyPrice };
}
